module.exports = __webpack_public_path__ + "static/img/Waterway freight picture.daa9dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Waterway freight picture.png
// module id = lgHb
// module chunks = 44